module.exports = __webpack_public_path__ + "img/spiral-details5.eda43181.png";